import React from 'react'
import { useNavigate } from 'react-router-dom';
import { midoriTeamList } from '../../utils/helper';
import { FaHome } from 'react-icons/fa';

const MidoriTeams = () => {

    const navigate = useNavigate();

    const headers = ['Sl. No.', 'DISTRICT', 'Health Center', 'ASHA', 'ANM/CHO', 'FC Teams']

    return (
        <div className="role-container">
            <div className="filters-container">
                <button onClick={() => navigate(-1)} className="filter-button"><FaHome /> Home</button>
                <span style={{ fontSize: '35px' }}>Screening Teams</span>
                <div style={{ opacity: 0 }} className="filter-container"></div>
            </div>
            <div style={{ marginTop: 20 }} className="fm-item-container">
                <table className="fm-item-table">
                    <thead>
                        <tr>
                            {headers.map((th, idx) => {
                                return (
                                    <th key={idx} style={{ backgroundColor: '#217cc070', maxWidth: '200px' }}>{th}</th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {midoriTeamList?.map((item, idx) => {
                            return (
                                <tr key={idx}>
                                    <td style={{ maxWidth: '200px', wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}>{item?.sl_no}</td>
                                    <td style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}>{item?.district}</td>
                                    <td style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}>{item?.health_center}</td>
                                    <td style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}>{item?.asha}</td>
                                    <td style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}>{item?.anm_cho}</td>
                                    <td style={{ maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}>{item?.fc_teams}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default MidoriTeams